import { Component, effect, ElementRef, inject, OnInit, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as Sentry from '@sentry/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sp-feedback-button',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './feedback-button.component.html',
  styleUrl: './feedback-button.component.scss'
})
export class FeedbackButtonComponent {
  readonly translate = inject(TranslateService);
  readonly button = viewChild('button', { read: ElementRef });

  constructor() {
    const feedback = Sentry.getFeedback();

    effect(() => {
      const button = this.button();

      if (!button) return;

      console.log(button.nativeElement);

      feedback?.attachTo(button.nativeElement, this.getFeedbackConfiguration());
    });
  }

  private getFeedbackConfiguration() /* : FeedbackTextConfiguration */ {
    return {
      
      formTitle: this.translate.instant('sentry.feedback.formTitle'),
      triggerLabel: this.translate.instant('sentry.feedback.triggerLabel'),
      triggerAriaLabel: this.translate.instant('sentry.feedback.triggerAriaLabel'),
      cancelButtonLabel: this.translate.instant('common.cancelLabel'),
      submitButtonLabel: this.translate.instant('sentry.feedback.submitButtonLabel'),
      nameLabel: this.translate.instant('sentry.feedback.nameLabel'),
      namePlaceholder: this.translate.instant('sentry.feedback.namePlaceholder'),
      emailLabel: this.translate.instant('sentry.feedback.emailLabel'),
      emailPlaceholder: this.translate.instant('sentry.feedback.emailPlaceholder'),
      messageLabel: this.translate.instant('sentry.feedback.messageLabel'),
      messagePlaceholder: this.translate.instant('sentry.feedback.messagePlaceholder'),
      addScreenshotButtonLabel: this.translate.instant('sentry.feedback.addScreenshotButtonLabel'),
      removeScreenshotButtonLabel: this.translate.instant('sentry.feedback.removeScreenshotButtonLabel'),
      isRequiredLabel: this.translate.instant('sentry.feedback.isRequiredLabel'),
      successMessageText: this.translate.instant('sentry.feedback.successMessageText'),
    };
  }
}
